export default function MobileCallButton() {
  return (
    <a
      href="tel:905-226-0408"
      className="fixed bottom-6 left-0 right-0 mx-6 lg:hidden z-40 flex items-center justify-center gap-3 bg-red-600 hover:bg-red-700 text-white px-6 py-4 rounded-full font-rajdhani font-bold text-lg shadow-2xl transition-all duration-300 whitespace-nowrap cursor-pointer"
    >
      <i className="ri-phone-fill text-xl"></i>
      CALL NOW – 905-226-0408
    </a>
  );
}
